// extracted by mini-css-extract-plugin
export default {"shimmer":"TransactionTypeBadge_shimmer__n1qag","dark_shimmer":"TransactionTypeBadge_dark_shimmer__OkbCu","badge":"TransactionTypeBadge_badge__kI-wS"};